import React from 'react';

const SectionHeader = ({ name }) => {
	return (
		<div 
			className='header-blue'
			style={{}}
		>
        	<h2>{name}</h2>
      	</div>
		)
}

export default SectionHeader;

